import type { PriorDocument } from './LifecyclePriorDocPicker';

/** Staging reference; the compiler resolves the linked document to its published leaf ID. */
export function priorDocumentReference(prior: PriorDocument): string {
  const leafId = (prior.FileName || '').replace(/[^a-zA-Z0-9_-]/g, '-');
  return `../../../${prior.SubSequenceNumber ?? ''}/index.xml#${leafId}`;
}
